import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { PLACEHOLDER } from '../../constants.js';
import { formatPowerValues } from '../../ContactLensesUtils.js';
import { PowerSelector } from '../PowerSelector/PowerSelector.js';
import { ReadOnlyElement } from '../ReadOnlyElement/ReadOnlyElement.js';
import { SelectElement } from '../SelectElement/SelectElement.js';

const SelectContainer = ({ attributes , activeFilters , id , handleAttributeChange , hasError , isActive , foundProduct ,  })=>{
    const selectors = [];
    // Defined order of the selector elements
    const sortSelectorOrder = [
        'color',
        'power',
        'baseCurve',
        'diameter',
        'axis',
        'addition',
        'cylinder', 
    ];
    const attributeKeys = sortSelectorOrder.filter((key)=>Object.keys(attributes).includes(key)
    );
    // Render selector elements
    attributeKeys.forEach((key)=>{
        const currentKey = key;
        const props = {
            attribute: currentKey,
            attributes,
            activeFilters,
            id,
            handleAttributeChange,
            hasError,
            isActive,
            foundProduct
        };
        if (!attributes[currentKey]) {
            return;
        }
        if (currentKey === 'packageQuantity') {
            return;
        }
        if (currentKey === 'power') {
            const allPowerOptions = attributes.power ? formatPowerValues(attributes.power.values) : [];
            const onlyOneOptionAvailble = allPowerOptions.length <= 1;
            // value to set within PrescriptionDropdown via placeholder prop when selected
            // needed because of the isMobile render check below
            const initialValue = (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.power) || PLACEHOLDER;
            const powerProps = swcHelpers.objectSpread({}, props, {
                options: allPowerOptions,
                initialValue
            });
            if (onlyOneOptionAvailble) {
                return selectors.push(/*#__PURE__*/ React__default.createElement(ReadOnlyElement, {
                    key: key,
                    attribute: powerProps.attribute,
                    value: initialValue,
                    id: id
                }));
            }
            return selectors.push(/*#__PURE__*/ React__default.createElement(PowerSelector, swcHelpers.extends({
                key: key
            }, powerProps)));
        } else {
            return selectors.push(/*#__PURE__*/ React__default.createElement(SelectElement, swcHelpers.extends({
                key: key
            }, props)));
        }
    });
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, selectors);
};

export { SelectContainer };
//# sourceMappingURL=SelectContainer.js.map
